import React, { useRef, useEffect, useState } from 'react';
import "./index.css";


type DeviceControlItemInputRange = {
  title: string
  open: boolean
  value: number
  onValue(value: number): void
  style?: React.CSSProperties
  className?: string
}
/**
 * 计数按钮
 */


function DeviceControlItemInputRange(props: DeviceControlItemInputRange) {

  const [value, setValue] = useState(props.value)

  useEffect(() => {

    setValue(props.value)

  }, [props.value])

  return (
    <div
      className={props.className}
      style={{
        borderRadius: 10,
        padding: 16,
        ...props.style || {},
      }}
    >
      <div
        className='flex'
        style={{
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <span
          style={{
            fontSize: 18,
            fontWeight: '700',
            color: 'rgba(0,0,0,0.7)',
          }}
        >{props.title}</span>
        <div
          style={{
            fontSize: 12,
            fontWeight: '700',
            color: props.open ? '#65895C' : '#8E0300',
            backgroundColor: props.open ? '#EBF4EB' : '#F8EDEC',
            padding: '4px 10px',
            borderRadius: 20,
          }}
        >
          {props.open ? 'ON' : 'OFF'}
        </div>
      </div>
      <div
        className='flex'
        style={{
          flexDirection: 'row',
          justifyContent: 'space-between',
          marginTop: 15,
        }}
      >
        <input
          className="device_control_input_range"
          style={{
            color: 'red',
          }}
          type="range"
          value={value}
          onChange={event => setValue(Number(event.target.value || 1))}
          min={1}
          max={100}
          step={1}
          onTouchEnd={(event: any) => props.onValue(Number(event.target.value))}
        />

        <div
          style={{
            color: 'rgba(0,0,0,0.5)',
            fontWeight: '800',
            fontSize: 30,
            width: 120,
            textAlign: 'right',
          }}
        >
          {(props.value || 0) + "%"}

        </div>
      </div>
    </div>
  );
}

export default DeviceControlItemInputRange;
